export const ATTACHMENT = 'attachment';
export const CSS = 'text/css';
export const CSV = 'text/csv';
export const FORM_URL_ENCODED = 'application/x-www-form-urlencoded';
export const GRAPHQL = 'application/graphql';
export const HTML = 'text/html';
export const JSON = 'application/json';
export const M3U8 = 'application/vnd.apple.mpegurl';
export const DASH = 'application/dash+xml';
export const MOV = 'video/quicktime';
export const MP2T = 'video/MP2T';
export const MP4 = 'video/mp4';
export const MULTIPART_FORM_DATA = 'multipart/form-data';
export const PDF = 'application/pdf';
export const PLAIN_TEXT = 'text/plain';
export const XML = 'text/xml';
export const WEBM = 'video/webm';
export const PNG = 'image/png';
export const JPEG = 'image/jpeg';
export const GIF = 'image/gif';

export const MIME_TYPE_AVI = 'video/avi';
export const MIME_TYPE_AVI_VND = 'video/vnd.avi';
export const MIME_TYPE_AVI_MSVIDEO = 'video/msvideo';
export const MIME_TYPE_AVI_X_MSVIDEO = 'video/x-msvideo';

export const MIME_TYPE_WMA = 'audio/x-ms-wma';
export const MIME_TYPE_WMV_ASF = 'application/vnd.ms-asf';
export const MIME_TYPE_WMV = 'video/x-ms-asf';
export const MIME_TYPE_WMV_VIDEO = 'video/x-ms-wmv';

export const MIME_TYPE_M4V_VIDEO = 'video/x-m4v';

export const ALLOWED_VIDEO_UPLOAD_MIMES = [
  MP4,
  MOV,
  WEBM,
  MIME_TYPE_M4V_VIDEO,
  MIME_TYPE_WMA,
  MIME_TYPE_WMV,
  MIME_TYPE_WMV_ASF,
  MIME_TYPE_WMV_VIDEO,
  MIME_TYPE_AVI,
  MIME_TYPE_AVI_VND,
  MIME_TYPE_AVI_MSVIDEO,
  MIME_TYPE_AVI_X_MSVIDEO,
];

const FILE_EXTENSION_MP4 = '.mp4';
const FILE_EXTENSION_MOV = '.mov';
const FILE_EXTENSION_WEBM = '.webm';
const FILE_EXTENSION_WMV = '.wmv';
const FILE_EXTENSION_AVI = '.avi';
const FILE_EXTENSION_M4V = '.m4v';

export const ALLOWED_VIDEO_UPLOAD_EXTENSIONS = new Set([
  FILE_EXTENSION_MP4,
  FILE_EXTENSION_MOV,
  FILE_EXTENSION_WEBM,
  FILE_EXTENSION_WMV,
  FILE_EXTENSION_AVI,
  FILE_EXTENSION_M4V,
]);
